module.exports = __webpack_public_path__ + "img/selected1-min.3e6adef9.png";